/** @jsxImportSource @emotion/react */
import React from 'react'
import {
  gameInfoStyle,
  gameTimeStyle,
  leagueNameStyle,
  arenaInfoStyle,
} from '../styles'

/**
 * Props for the GameInfo component
 */
export interface GameInfoProps {
  /** Whether game time is TBD */
  isGameTimeToBeDefined: boolean
  /** Date string displayed when time is TBD */
  gameDateWithoutTime: string | null
  /** Formatted game date/time string */
  gameTime: string
  /** Name of the league/schedule */
  leagueName: string
  /** Venue name */
  arenaName: string
  /** Facility number/name */
  facilityNumber: string
}

/**
 * Displays game time, league name, and arena/facility information.
 * Handles TBD game times with a fallback date display.
 *
 * @param {GameInfoProps} props - Component props
 * @returns {JSX.Element} Game information display
 */
const GameInfo: React.FC<GameInfoProps> = ({
  isGameTimeToBeDefined,
  gameDateWithoutTime,
  gameTime,
  leagueName,
  arenaName,
  facilityNumber,
}) => {
  return (
    <div css={gameInfoStyle}>
      {isGameTimeToBeDefined ? (
        <>
          {gameDateWithoutTime ? (
            <p css={gameTimeStyle}>TBD - {gameDateWithoutTime}</p>
          ) : null}
        </>
      ) : (
        <p css={gameTimeStyle}>{gameTime}</p>
      )}
      <p css={leagueNameStyle}>{leagueName}</p>
      <p css={arenaInfoStyle}>{`${facilityNumber} ${
        arenaName ? `- ${arenaName}` : ''
      }`}</p>
    </div>
  )
}

export default React.memo(GameInfo)
